import React from 'react';
import { TextBox } from '../../../components/ui/TextBox';
import { Button } from '../../../components/ui/Button';
import { Table, Column } from '../../../components/ui/Table';
import { IconButton, EyeIcon, PencilIcon, TrashIcon } from '../../../components/ui/IconButton';
import { Machine } from '../../../types/machines';
import { Badge } from '../../../components/ui/Badge';

export type ListViewProps = {
  data: Machine[];
  total: number;
  page: number;
  pageSize: number;
  setPage: (p: number) => void;
  setPageSize: (s: number) => void;
  query: string;
  setQuery: (q: string) => void;
  loading?: boolean;
  error?: string | null;
  onCreate: () => void;
  onView: (id: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
};

export const MachinesListView: React.FC<ListViewProps> = props => {
  const columns: Column<Machine>[] = [
    { key: 'name', header: 'Name' },
    { key: 'location', header: 'Location' },
    { key: 'serialNumber', header: 'Serial #' },
    { key: 'status', header: 'Status', width: 120, render: (r) => (
      <Badge variant={r.status === 'online' ? 'success' : 'destructive'}>
        {r.status}
      </Badge>
    ) },
    {
      key: 'actions',
      header: 'Actions',
      width: 140,
      render: (row: Machine) => (
        <div className="flex items-center gap-2">
          <IconButton title="View" onClick={() => props.onView(row.id)}>
            <EyeIcon />
          </IconButton>
          <IconButton title="Edit" onClick={() => props.onEdit(row.id)}>
            <PencilIcon />
          </IconButton>
          <IconButton
            title="Delete"
            onClick={() => props.onDelete(row.id)}
          >
            <TrashIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Machines</h1>
        <Button onClick={props.onCreate}>New Machine</Button>
      </div>
      <div className="mb-3 flex items-center gap-2">
        <TextBox placeholder="Search by name, location, serial" value={props.query} onChange={e => props.setQuery(e.target.value)} />
      </div>
      {props.error && <div className="mb-2 text-sm text-destructive">{props.error}</div>}
      <Table
        columns={columns}
        data={props.data}
        page={props.page}
        pageSize={props.pageSize}
        total={props.total}
        onPageChange={props.setPage}
        onPageSizeChange={props.setPageSize}
      />
    </div>
  );
};

export default MachinesListView;
